module.exports = __webpack_public_path__ + "static/media/opi-illustration.45ca4e3d.svg";